import * as z from "zod/v4";

export const updateReturnWithWaivedShippingFee = {
  name: "updateReturnWithWaivedShippingFee" as const,
  input: z.object({ id: z.string(), waivedShippingFee: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
